import PropTypes from 'prop-types'

export default {
  event: PropTypes.object.isRequired,
  renderDate: PropTypes.object.isRequired,
  onEventChange: PropTypes.func.isRequired,
}
